import React from 'react'

const userSettingsComponent = ({ user }) => (
  <div className="userSettings">
    <h1>Settings</h1>
    <div className="userSettings__section">
      <div className="userSettings__section__l">
        Email
      </div>
      <div className="userSettings__section__r">
        {user.email}
      </div>
    </div>
    <div className="userSettings__section" style={{ borderBottom: 'none' }}>
      <div className="userSettings__section__l">
        Password
      </div>
      <div className="userSettings__section__r">
        {user.googleId ? 'You\'re using Google to sign in' : (
          <b
            href="/settings"
            style={{ fontSize: 12 }}
          >
            Reset password
          </b>
        )
        }
      </div>
    </div>
  </div>
)

export default userSettingsComponent
